import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import {push} from 'react-router-redux';
import * as commonActions from './../../actions/commonActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as authActions from '../../redux/modules/auth';
import styles from './TradeBook.less';
import config from './../../config';
import DatePicker from 'react-datepicker';
import TimeField from 'react-simple-timefield';
import appConstants from './../../appConstants';
import Modal from 'react-modal';
import i18next from 'i18next';
import renderHTML from 'react-render-html';
import { applyStyle, applyClickActive,applyToHover,getSeparator, setDirection,unformatLang } from './../../utils/utils';
import 'react-datepicker/dist/react-datepicker.css';
import {
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Tabs,
  Tab,
  Button,
  Checkbox
} from 'react-bootstrap';
import moment from 'moment';
import track from 'react-tracking';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

let CmdtyAsk;
let CmdtyBid;
let CmdtyPair;
let CmdtyAskArray;
let CmdtyBidArray;
let ValueDate;
let D1;
let T1;
let rateDiff;
let variationInAsk;
let variationInBid;
let lmtordNo = [];
let index1=0;
let separator;
let decimal;
let decimalCount = 0;
let wsData;
// const elementsData = [
//   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part1TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part2TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"rateDiff","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"buyBg","elementType":"normal", "applyTo":"single", "tagNames":"button"},
//   {"classNames":"sellBg","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
//   {"classNames":"trdDropDown","elementType":"tag", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"dropDownList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"trdComments","elementType":"normal", "applyTo":"all", "tagNames":"textarea"}
// ];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIconMdfy","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
  {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col4","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"submitBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lmtMeasureDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lmtCmdtyDrpdown","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText","elementType":"normal", "applyTo":"all", "tagNames":"span"}
];
@connect(
state => ({
            userDetail:state.auth.userDetail,
            trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
            trdingFlag: state.dashboardRoot.tradepanelReducer.trdingFlag,
            status: state.dashboardRoot.instrumentListReducer.status,
            limitOrdBook: state.dashboardRoot.activityReducer.limitOrdBook,
            lmtModifyFlag:state.dashboardRoot.tradeBookReducer.lmtModifyFlag,
            closeLmtModifypopup:state.dashboardRoot.tradeBookReducer.closeLmtModifypopup,
            socketData: state.dashboardRoot.instrumentListReducer.socketData,
            socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
            check: state.dashboardRoot.instrumentListReducer.check,
            cmdtyArr: state.dashboardRoot.instrumentListReducer.cmdtyArr,
            selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
            selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
            stkWiseMarkup:state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
			      selectedLang:state.dashboardRoot.commonReducer.selectedLang,
            language:state.dashboardRoot.commonReducer.language,
            stkWiseMarkupRandomNo:state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
            orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
            custInstStkData: state.dashboardRoot.instrumentListReducer.custInstStkData,
          }),{...tradeBookActions,
              ...tradepanelActions,
              ...instrumentListActions,
              ...activityActions,
              ...dashboardActions,
              ...commonActions,
              ...authActions})
              
@track(() => ({}))

export default class ModifyLMTOrderComponent extends Component
{
  static propTypes =
   {
     closeLmtModifypopup: PropTypes.func,
     validateOrder: PropTypes.func,
     lmtModifyFlag:PropTypes.bool,
     setOrdersCTID:PropTypes.func,
     handleLimitModal:PropTypes.func,
     stkWiseMarkup:PropTypes.object,
     stkWiseMarkupRandomNo:PropTypes.Number,
     custInstStkData:PropTypes.array
   };
   state = {
    showLmtDialog:false,
    time:moment().format("hh:mm"),
    actualTime:moment('01:00 PM', ["h:mm A"]).format("HH:mm"),
    selectedMeasureLmt: '',
    DFLMT:[],
    OrderType:0,
    startDatePop:moment(),
    COMLM:null,
    LMTModel: false,
    cmdtyIndex:0,
    errorMsg:'',
    CTID:'',
    ordNo:'',
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    DealTypeLang:'',
    showPrice:'',
    disableSubmit:false,
    MEASURE:[],
    isCustInst:false
    }
   constructor() {
     super();
     this.handleChange = this.handleChange.bind(this);
     this.onTimeChange = this.onTimeChange.bind(this);
     window.modifyLmtOrder = this.modifyLmtOrder.bind(this);
     this.afterOpenModal = this.afterOpenModal.bind(this);
   }
   componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
      {"elmToHover":thisComponent.getElementsByClassName("dropDownList")[0], "classNames":"dropDownList"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
     //this.setState({CTID:this.props.CTID});
     const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
     this.setState({showPrice:showPrice});
     lmtordNo = this.props.selectLmtRow;
     const selectedOrd=lmtordNo[0];
     let orderDetails = this.props.limitOrdBook.limitOrdMap.get(selectedOrd.orderNo);
     if((orderDetails.deal === 'BUY'&&showPrice!=='ASK')||(orderDetails.deal === 'SELL'&&showPrice!=='BID')||
      (orderDetails.deal === 'STOP BUY'&&showPrice!=='ASK')||(orderDetails.deal === 'STOP SELL'&&showPrice!=='BID')){
       if(showPrice!=='BOTH'){
         this.setState({disableSubmit:true});
       }
     }
     orderDetails['DealTypeLang'] = orderDetails.deal === 'BUY' ? i18next.t('BUY') :
     orderDetails.deal === 'SELL' ? i18next.t('SELL') :  orderDetails.deal === 'STOP BUY' ?
     i18next.t('STOPBUY') : i18next.t('STOPSELL');
     this.setState({DealTypeLang:orderDetails.DealTypeLang});
     this.setState({ordNo: orderDetails.orderNo});
     this.setState({selectedLmtRmk: orderDetails.comments.trim()});
     this.setState({CTID:orderDetails.CTID});
     this.props.setTradingstatus(localStorage.getItem('TRD_STATUS'));
     this.setState({DealType: orderDetails.deal});
     this.setState({startDatePop:moment(parseFloat(orderDetails.TIME))});
     this.setState({time:moment(parseFloat(orderDetails.TIME)).format('hh:mm'),
     validationTime:(moment(parseFloat(orderDetails.TIME)).format('hh:mm')).substring(0, 2),
     actualTime:moment(moment(parseFloat(orderDetails.TIME)).format("hh:mm")+" "+moment(parseFloat(orderDetails.TIME)).format("A"), ["h:mm A"]).format("HH:mm"),
     timeFormat:moment(parseFloat(orderDetails.TIME)).format("A")});
     if((orderDetails.deal).toUpperCase() === config.buy || (orderDetails.deal).toUpperCase() === config.stopBuy){
       this.setState({OrderType:1});
     }
     else{
       this.setState({OrderType:0});
     }
     this.setState({Validty: (parseInt(orderDetails.VT) === appConstants.GTD ? "GTD" : (parseInt(orderDetails.VT) === appConstants.DAY ? "DAY" :
     parseInt(orderDetails.VT) === 60 ?"GTT": "GTC"))});
     this.setState({ValidtyKey: orderDetails.VT});
     this.setState({selectedQuantityLmt: orderDetails.quantity});
     this.setState({Price: orderDetails.OR});
     this.setState({selectedCmdtyPairKey:orderDetails.cmdtyId});
     const length = this.props.socketDataStatic.length;
     for (let index = 0; index < length; index++) {
       const cmdty = this.props.socketDataStatic[index].I;
       const cmdtyDes = this.props.socketDataStatic[index].ID;
       if (cmdtyDes === orderDetails.cmdtyPair) {
          index1=index;
          break;
       }
     }
     //this.setState({cmdtyIndex: index1});
     //var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
     CmdtyPair = this.props.socketDataStatic[index1].cmdty;
     //CmdtyAsk = this.props.socketData[index].ask;
     //CmdtyBid = this.props.socketData[index].bid;
     //rateDiff = this.props.socketData[index].diff;
     D1 = this.props.socketDataStatic[index1].D1;
     this.setState({COMLM:parseInt(this.props.socketDataStatic[index1].B)});
     this.setState({isCustInst:parseInt(this.props.socketDataStatic[index1].C) !== 32 ? false : true});
     this.setState({cmdtyID:this.props.socketDataStatic[index1].I});
     variationInAsk = this.props.socketDataStatic[index1].variationInAsk;
     const dealLimit = this.props.socketDataStatic[index1].dealLimit;
     const validDate = this.props.socketDataStatic[index1].VD;
     ValueDate=this.props.socketDataStatic[index1].VD;
     variationInBid = this.props.socketDataStatic[index1].variationInBid;
     var dec=this.props.socketDataStatic[index1].dec;
     // this.setState({selectedCmdty:orderDetails.cmdtyPair});
     T1=this.props.socketDataStatic[index1].T1;
     this.setState({T1:T1});
     // const DF=this.props.socketDataStatic[index1].DF;
     // const DFParse=JSON.parse(DF);
     // this.setState({DFLMT: DFParse});
     const unit = [];
     var tmpConvFactor=new Map();
     const lengthTrdData = this.props.trdPanelData.length;
     for (let index = 0; index < lengthTrdData; index++) {
       const stk_type = this.props.trdPanelData[index].stk_type;
       if (stk_type === T1) {
         unit.push(this.props.trdPanelData[index].C);
         tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
       }
     }
     /// conversion factor for custom instrument
     if(this.props.custInstStkData !==undefined){
     for (let index = 0; index < this.props.custInstStkData.length; index++) {
       const stk_type = this.props.custInstStkData[index].S;
       if (stk_type === T1) {
         tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
       }
     }
   }
     this.getStkWiseMarkup(orderDetails.OSC,this.props.socketDataStatic[index1].I,this.props.stkWiseMarkup);
     this.setState({convFactorLM:tmpConvFactor});
     this.setState({MEASURE:unit});
     this.setState({selectedMeasureLmt:orderDetails.OSC});
     for (let index = 0; index < lengthTrdData; index++) {
       const stk_type = this.props.trdPanelData[index].stk_type;
       const type = this.props.trdPanelData[index].C;
       if (T1===stk_type && type===orderDetails.OSC) {
         const DF = this.props.trdPanelData[index].DF;
		       const conv_Factor = this.props.trdPanelData[index].F;
         const DFParse=JSON.parse(DF);
         this.setState({DFLMT:DFParse});
         this.setState({convFact:conv_Factor});
       }else if((this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===1)||
         (this.props.socketDataStatic[index1].B===1 && this.props.socketDataStatic[index1].C===2) ||  this.props.socketDataStatic[index1].C===32){
         const DF=this.props.socketDataStatic[index1].DF;
         const DFParse=JSON.parse(DF);
         this.setState({DFLMT: DFParse});
       }
     }
     //this.props.subscribeTier(socketDataMap.I,this.props.webSocketFlag);
   }
   componentWillReceiveProps(nextProps){
     if(nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo){
       this.getStkWiseMarkup(this.state.selectedMeasureLmt,this.state.cmdtyID,nextProps.stkWiseMarkup);
     }
     if(nextProps.userDetail.showPrice!==this.state.showPrice){
       if(nextProps.userDetail.showPrice!==undefined&&nextProps.userDetail.showPrice!=="undefined"){
         const showPrice = nextProps.userDetail.showPrice===undefined||nextProps.userDetail.showPrice==="undefined"?"BOTH":nextProps.userDetail.showPrice;
         this.setState({showPrice:showPrice});
         lmtordNo = this.props.selectLmtRow;
         const selectedOrd=lmtordNo[0];
         let orderDetails = this.props.limitOrdBook.limitOrdMap.get(selectedOrd.orderNo);
         if((orderDetails.deal === 'BUY'&&showPrice!=='ASK')||(orderDetails.deal === 'SELL'&&showPrice!=='BID')){
           if(showPrice!=='BOTH'){
             this.setState({disableSubmit:true});
           }else{
             this.setState({disableSubmit:false});
           }
         }else{
           this.setState({disableSubmit:false});
         }
       }
     }
   }
   getStkWiseMarkup = (stk_code,cmdty,stkWiseMarkup) =>{
    try{
     if(stk_code!==undefined && stk_code!==""){
       if(stkWiseMarkup!==null){
         let stkCodeMarkup=stkWiseMarkup.get(cmdty);
         if(stkCodeMarkup !== undefined){
           for(let i=0;i<stkCodeMarkup.length;i++){
             if(stkCodeMarkup[i].SC===stk_code){
               this.setState({stkWiseAskMarkup: stkCodeMarkup[i].ASK,stkWiseBidMarkup: stkCodeMarkup[i].BID});
             }
           }
         }
       }
     }else{
       this.setState({stkWiseAskMarkup: 0,stkWiseBidMarkup: 0});
     }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"ModifyLMTOrderComponent"});
    }
   }
  quantitySelectionLmt = (event) => {
    try{
      if(event.target.text==="")
      {
        event.target.text="0"
      }
      var check= event.target.text.slice(event.target.text.length-1);
      var tempQ= event.target.text;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
      //convFactor
        this.setState({selectedQuantityLmt: tempQ});
        this.setState({selectedQuantityLmtINPUT: event.target.text});
      // if(this.state.COM===1){
      // 	tempQ=parseFloat(tempQ);
      // }
      // else{
      // 	tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.selectedMeasureLmt));
      // }
      //tempQ=tempQ.toFixed(2);
      //this.setState({selectedQuantityLmt: tempQ});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionLmt', component:"ModifyLMTOrderComponent"});
    }
  }
  quantityTypedLmt = (event) => {
    try{
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
        event.target.value="0"+event.target.value;
      }
      var flag=0;
      var c=0;
      for(var i=0;i<event.target.value.length;i++){
        if(event.target.value.charAt(i)=== checkDecimal){
          flag=1;
        }
        if(flag==1){
          c++;
        }
      }
      if(c>4){
        event.target.value= this.state.selectedQuantityLmt;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
      var check= event.target.value.slice(event.target.value.length-1);
      var tempQ= event.target.value;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
        if(!isNaN(tempQ)){
        this.setState({selectedQuantityLmt: tempQ});
        }else{
        this.setState({selectedQuantityLmt: event.target.value});
      }
    }
     else{
       this.setState({selectedQuantityLmt: event.target.value});
     }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantityTypedLmt', component:"ModifyLMTOrderComponent"});
    }
  }
  onBlurLMT= (event)=> {
    try{
      var tempQ=event.target.value;
      if(tempQ===""){
        tempQ = "";
      }
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
        event.target.value="0"+event.target.value;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
        var check= event.target.value.slice(event.target.value.length-1);
        tempQ= event.target.value;
        tempQ = unformatLang(tempQ);
          if(check.toUpperCase()==='K')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000;
          }
          else if(check.toUpperCase()==='M')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000000;
          }
          if(!isNaN(tempQ) && tempQ !=="" && tempQ !== 0)
          {

            tempQ= event.target.value;
            tempQ = unformatLang(tempQ);
            if(tempQ==="" || tempQ==="NaN" ){
              tempQ ="";
            }
          var tempQuant=Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3});
          // var tempQuant=Number.isInteger(parseFloat(tempQ))?tempQ:Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
          // tempQuant=(tempQuant).replace(getSeparator(navigator.language,'group'),"");
          this.setState({selectedQuantityLmt: tempQuant});
          tempQuant=unformatLang(tempQuant);
          this.setState({selectedQuantityLmtINPUT: event.target.value});
          tempQ=parseFloat(tempQ).toFixed(2);
          }
          else{
            if(event.target.value===""){
              tempQ = "";
            }
            this.setState({selectedQuantityLmt: tempQ});
            this.setState({selectedQuantityLmtINPUT: event.target.value});
          }
        }
      else{
          if(tempQ===""){
            tempQ = "";
          }
          if(!isNaN(tempQ)){
            this.setState({selectedQuantityLmt:Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3})});
          } else{
            this.setState({selectedQuantityLmt:tempQ});
            this.setState({selectedQuantityLmtINPUT:event.target.value});
          }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurLMT', component:"ModifyLMTOrderComponent"});
    }
  }
  selectMeasureLmt = (event) => {
    try{
      this.setState({selectedMeasureLmt: event.target.text});
      this.setState({selectedMeasureLmtINPUT: event.target.text});
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1===stk_type && type===event.target.text) {
            const DF = this.props.trdPanelData[index].DF;
            const DFParse=JSON.parse(DF);
            this.setState({DFLMT:DFParse});
        }
      }
      this.getStkWiseMarkup(event.target.text,this.state.cmdtyID,this.props.stkWiseMarkup);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureLmt', component:"ModifyLMTOrderComponent"});
    }
  }
  closeLmtModal = (event) => {
    try{
      this.setState({showLmtDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLmtModal', component:"ModifyLMTOrderComponent"});
    }
  }
  closeLimitOrdpopup = (event) => {
    try{
      this.props.closeLmtModifypopup(false);
      this.props.handleLimitModal(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLimitOrdpopup', component:"ModifyLMTOrderComponent"});
    }
  }
  handleChange = (date) => {
    try{
      this.setState({startDatePop: date});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleChange', component:"ModifyLMTOrderComponent"});
    }
  }
  onTimeChange  = (time) => {
    try{
      this.setState({time:time});
      this.setState({actualTime:moment(time+" "+this.state.timeFormat, ["h:mm A"]).format("HH:mm"),
      validationTime:(time).substring(0, 2),});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onTimeChange', component:"ModifyLMTOrderComponent"});
    }
  }
  onBlurTime = (event) =>{
    try{
      this.setState({time:event.target.value});
      this.setState({timeINPUT:event.target.value});
      this.setState({actualTime:moment(event.target.value+" "+this.state.timeFormat, ["h:mm A"]).format("HH:mm"),
      validationTime:(event.target.value).substring(0, 2)});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurTime', component:"ModifyLMTOrderComponent"});
    }
  }
  onSelectTimeFormat=(timeFormat) =>{
    try{
      this.setState({timeFormat:timeFormat});
      this.setState({actualTime:moment(this.state.time+" "+timeFormat, ["h:mm A"]).format("HH:mm")});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onSelectTimeFormat', component:"ModifyLMTOrderComponent"});
    }
  }
  checkNumberValue =(event) =>{
    try{
      if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal) && (event.which !== 107) && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)){
          event.preventDefault();
        }
      if(event.target.value.indexOf(decimal)===-1){
            decimalCount = 0;
      }
      // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
      //     event.preventDefault();
      // }
      if(event.which === decimal.charCodeAt(0)){
        decimalCount+=1;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"ModifyLMTOrderComponent"});
    }
  }
  onBlurPrice = (event) =>{
    try{
      var price=event.target.value;
      price = unformatLang(price);
      var dec;
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        if(this.state.selectedCmdtyPairKey === this.props.socketDataStatic[index].I){
          dec= this.props.socketDataStatic[index].dec;
          break;
        }
      }
        if(price !=='' && !isNaN(price) && price !== 0){
        price=Number(price).toLocaleString(navigator.language,{minimumFractionDigits:dec,maximumFractionDigits:dec});
        // price=price.replace(getSeparator(navigator.language,'group'),"");
        // price=price.toFixed(dec);
        if(price === "NaN" || (price === "" && price != 0)){
        price="";
        }
      }
      if(event.target.value === "" || event.target.value === decimal){
      price=event.target.value;
      }
      this.setState({Price: price});
      this.setState({PriceINPUT: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurPrice', component:"ModifyLMTOrderComponent"});
    }
  }
  changePrice = (event) => {
    try{
      // if(event.target.value.indexOf(separator)!=-1 && separator !== ''){
      //   event.preventDefault();
      // }
      // else {
        this.setState({Price: event.target.value});
      // }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changePrice', component:"ModifyLMTOrderComponent"});
    }
  }
  onBlurLMTRmk = (event) => {
    try{
      const rmk = event.target.value;
      this.setState({selectedLmtRmk: rmk});
      this.setState({selectedLmtRmkINPUT: rmk});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurLMTRmk', component:"ModifyLMTOrderComponent"});
    }
  }
  getWsDataModifyord = (CmdtyPair, tempQ, Measure, DealType, Price, orderType, OMT,PCT,remark,VT,CTID,datetime,OPQ,OR,OVT,OSC,NOD,BID,PCLD,DRMK,HSE,VD,AC,AD,OTIME)=>{
    try{
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet=JSON.parse(localStorage.getItem('DefaultAC'));
      if (user === null) {
        dispatch(sessionTimeout());
      }
      const platform = localStorage.getItem('platform');
      let symbol;
      let priceValue = Price;
      let quant = tempQ;
      if (!priceValue) {
        priceValue = 0;
      }
      if (quant === '') {
        quant = 0;
      }

      var obj={};
      obj.language=navigator.language;
      obj.platform=platform;
      obj.browser=navigator.userAgent
      obj.UID=user.UID;
      obj.UCD=user.trdCode;
      obj.UD=user.UD;
      obj.IID=CmdtyPair;
      obj.PQ=parseFloat(quant);
      obj.DT=DealType;
      obj.R=parseFloat(Price);
      obj.OT=orderType;
      obj.CID=user.location;
      obj.AC=AC;
      obj.AD=AD;
      obj.VD=VD;
      if(Measure==="")
      {
        obj.SC="";
      }else{
        obj.SC=Measure;
      }
      obj.ST="";
      obj.OMT=OMT;
      obj.PCT=PCT;
      obj.UUID=user.authToken;
      obj.RMK=remark;
      obj.SID=user.SID;
      obj.CTID=CTID;
      obj.VT=VT; //validity, ValidityType class
      obj.OMC=1;//order modification count
      obj.VTE=datetime ;//epoch UTC timestamp
      obj.OPQ=OPQ; //old PQ
      obj.OR=OR;
      obj.OVT=OVT;
      obj.OSC=OSC;
      obj.NOD=NOD;
      obj.BID=BID ;//check if this is needed in new system, can be managed in server
      obj.OTIME=OTIME; //old time for GTD orders
      obj.LM="admin";
      obj.MD="-1";
      obj.PCLD=PCLD;
      obj.DRMK=DRMK;
      obj.MT="MODIFY_ORDER";

      return obj
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getWsDataModifyord', component:"ModifyLMTOrderComponent"});
    }
  }
  lmtOrderValidate = (Com, selectedQuantity, selectedMeasure, Price, cmdtyRate, ValueDate, dealType) => {
    try{
      let inputData= {
        PQ:this.state.selectedQuantityLmtINPUT,
        SC:this.state.selectedMeasureLmtINPUT,
        R:this.state.PriceINPUT,
        RMK:this.state.selectedLmtRmkINPUT,
        VTE:this.state.timeINPUT,
        VD:ValueDate,
        DT:dealType,
        IID:this.state.cmdtyID,   //Added IID state only
        VT:this.state.ValidtyKey,
        language:navigator.language,
        platform:localStorage.getItem('platform'),
        MT:"MODIFY_ORDER",
        browser:navigator.userAgent
      }
      this.setState({inputData})
      var selectedQuantity = unformatLang(selectedQuantity);
      let flag = 0;
      if (Price == decimal) {
        flag = 1;
        this.setState({errorMsg:"enterValidPricemsg"});
        this.setState({showLmtDialog:true});
      }
      else{
        var Price = unformatLang(Price);
        var OrderType=0;
        if(this.state.DealType === 'BUY' || this.state.DealType === 'SELL'){
          OrderType=2;
        }else{
          OrderType=3;
        }
        selectedQuantity = selectedQuantity + "";
        var tempQ = selectedQuantity;
        var check = selectedQuantity.slice(selectedQuantity - 1);
        if (check.toUpperCase() === 'K') {
          tempQ = selectedQuantity.slice(check, -1);
          tempQ = parseFloat(tempQ) * 1000;
        }
        if (Com === 1 || this.state.isCustInst) {
          selectedMeasure = "";
        }
        let flag = 0;
        var error = '';
        this.setState({errorMsg:""});
        if (parseFloat(tempQ) === 0) {
          flag = 1;
          error += "<p>"+i18next.t('minEnterQty')+"</p>";
        }
        if(this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0){
          flag=1;
          error += "<p>"+i18next.t('fractionDigitErrMsg')+"</p>";
          //this.setState({errorMsg:"Please enter correct quantity"});
        }
        if(Price ==='' && flag!==1){
          flag = 1;
          error += "<p>"+i18next.t('enterGreaterPriceMsg')+"</p>";
        }
        let flag2=0;
        if ((Price === "0"||Price === 0) && flag!==1 ) {
          flag = 1;
          flag2=1;
          error += "<p>"+i18next.t('enterGreaterPriceMsg')+"</p>";
        }

        if(parseFloat(Price) === 0 && flag!==1){
          flag=1;
          error += "<p>"+i18next.t('enterGreaterPriceMsg')+"</p>";
        }
      var sockCmdty = this.props.socketData.get(this.state.cmdtyID);
      let askRate = sockCmdty.ask
      let bidRate = sockCmdty.bid
      if (askRate) {
        askRate = parseFloat(sockCmdty.ask) - this.state.stkWiseAskMarkup;
      }
      if (bidRate) {
        bidRate = parseFloat(sockCmdty.bid) - this.state.stkWiseBidMarkup;
      }
     var minPrice=parseFloat(sockCmdty.OV);
     var maxPrice=parseFloat(sockCmdty.MXOV);
      if (askRate && bidRate) {
        if (askRate > bidRate) {
          if (bidRate < Price && Price < askRate) {
            flag = 1;
            error += "<p>" + i18next.t('placeOrdOutsideSpreadMsg') + "</p>";
          }
        }
        else {
          if (askRate < Price && Price < bidRate) {
            flag = 1;
            error += "<p>" + i18next.t('placeOrdOutsideSpreadMsg') + "</p>";
          }
        }
      }
        var rate = dealType === 1 ? askRate : bidRate;
        if(Math.abs(rate - Price) < minPrice && flag !==1 ){
            flag = 1;
            error += "<p>"+i18next.t('priceEnteredTooCloseMsg')+"</p>";

        }
        // if(maxPrice > 0 && flag !==1){
        if(flag !==1){
            if(Math.abs(rate - Price) > maxPrice){
              flag = 1;
              error += "<p>"+i18next.t('ordFarFromCurrSpreadMsg')+"</p>";

            }
        }
        if((Price && flag2!==1) && flag!==1){
            if (dealType === 1 && flag!==1) {
                if(OrderType === 2){
                  if (Price > askRate) {
                    flag = 1;
                    error += "<p>"+i18next.t('priceEnterWrngSideOfMkt')+"</p>";
                  }
                }else {
                  if (Price < askRate) {
                    flag = 1;
                    error += "<p>"+i18next.t('priceEnterWrngSideOfMkt')+"</p>";
                  }
                }
            } else if (dealType === 0 && flag!==1) {
              if(OrderType === 2){
                  if (Price < bidRate) {
                    flag = 1;
                    error += "<p>"+i18next.t('priceEnterWrngSideOfMkt')+"</p>";
                  }
              }else {
                if (Price > bidRate) {
                  flag = 1;
                  error += "<p>"+i18next.t('priceEnterWrngSideOfMkt')+"</p>";
                }
              }
            }
        }
        if(this.state.Validty === 'GTD'){
          const tradeDayEnd = moment(this.props.userDetail.dayEndTime).utc().format('YYYY-MM-DD')
          if(this.state.startDatePop === null && flag!==1)
            {
              flag = 1;
              error += "<p>"+i18next.t('invalidDate')+"</p>";
            }
            var newdate=moment().add(this.props.userDetail.valDaysLimit,'days');
            newdate.set({hour:hour,minute:min,second:0,millisecond:0})
            var momentA = moment(this.state.startDatePop);
            var valTime=""+moment().local().format("hh:mm");
            var hour=parseInt(valTime.substring(0, valTime.indexOf(":")));
            var min =parseInt(valTime.substring(valTime.indexOf(":") + 1));
            var endTime = moment().startOf('day');
            if(momentA.isBefore(tradeDayEnd))
            {
              flag =1;
              error += "<p>"+i18next.t('expTimeGreaterThanCurr')+"</p>";
            }else if(momentA.isAfter(newdate)){
              flag =1;
              error += "<p>"+i18next.t("greaterThan")+" " +this.props.userDetail.valDaysLimit+ " "+i18next.t("withinDays")+"</p>";
            }
          }
          if(this.state.Validty === 'GTT'){
            if(this.state.startDatePop === null && flag!==1)
              {
                flag = 1;
                error += "<p>"+i18next.t('invalidDate')+"</p>";
              }
              if(this.state.time === '' && flag!==1)
              {
                flag = 1;
                error += "<p>"+i18next.t('invalidTime')+"</p>";
              }
            var newdate=moment().add(this.props.userDetail.valDaysLimit,'days');
            newdate.set({hour:hour,minute:min,second:0,millisecond:0})
            var momentA = moment(this.state.startDatePop);
            var valTime=""+this.state.actualTime;
            var hour=parseInt(valTime.substring(0, valTime.indexOf(":")));
            var min =parseInt(valTime.substring(valTime.indexOf(":") + 1));
            momentA.set({hour:hour,minute:min,second:0,millisecond:0})
            var endTime = moment().add(5, 'minute');
            var currentTime =moment();

            if(this.state.validationTime>=13){
              flag =1;
              error += "<p>"+i18next.t('twelveHrsValidation')+"</p>";
            }
            else if(momentA.isBefore(currentTime)){
              flag =1;
              error += "<p>"+i18next.t('expTimeGreaterThanCurr')+"</p>";
            }
            else if(momentA.isBefore(endTime)){
              flag =1;
              error += "<p>"+i18next.t('greaterThanFiveMin')+"</p>";
            }
            else if(momentA.isAfter(newdate)){
              flag =1;
              error += "<p>"+i18next.t("greaterThan")+" " +this.props.userDetail.valDaysLimit+ " "+i18next.t("withinDays")+"</p>";
            }
          }
        if(tempQ === ''){
          flag=1;
          error += "<p>"+i18next.t('minEnterQty')+"</p>";
        }
        this.setState({errorMsg:error});
        tempQ = parseFloat("" + tempQ);
        const orderDetails = this.props.limitOrdBook.limitOrdMap.get(lmtordNo[0].orderNo);
        let time;
        if(this.state.Validty === 'DAY'){
          time=moment().format('YYYY-MM-DD');
        }else if(this.state.Validty === 'GTD'){
          const sDate=moment(this.state.startDatePop).format('YYYY-MM-DD');
          let start_time = moment().local().format("HH:mm");
          let datetimeA = moment(sDate + " " + "00:00");
          var date=datetimeA;
          time=moment(this.state.startDatePop).format('YYYY-MM-DD');
        }else if(this.state.Validty === 'GTT'){
          const sDate=moment(this.state.startDatePop).format('YYYY-MM-DD');
          let start_time = this.state.actualTime;
          let datetimeA = moment(sDate + " " + start_time);
          var date=datetimeA;
          time=date.utc().valueOf();
        }else{
          var date = moment();
          date.format();
          time=date.utc().valueOf();
        }
        if (flag === 1) {
          this.setState({showLmtDialog: true});
        } else {
          if (this.props.userDetail.canTrade) {
            this.modifyLmtOrder(this.state.COMLM, this.state.cmdtyID, tempQ, selectedMeasure, dealType, Price, OrderType, ValueDate, this.state.selectedLmtRmk, this.state.ValidtyKey,orderDetails,time,inputData)
          } else {
            this.setState({showtrdFlagModal: true});
          }
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'lmtOrderValidate', component:"ModifyLMTOrderComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "modifyLmtOrder", event: appConstants.trackingEvents.MODIFY_ORDER},
    ordDetails: [wsData]
  }))

  modifyLmtOrder = (Com, CmdtyPair, selectedQuantity, selectedMeasure, DealType, Price, OrderType, ValueDate, rmk, ValidityType,orderDetails,validitytime,inputData) => {
    try{
      selectedQuantity = selectedQuantity + "";
      var tempQ = selectedQuantity;
      var check = selectedQuantity.slice(selectedQuantity - 1);
      const user = JSON.parse(localStorage.getItem('user'));
      this.props.setOrdersCTID(this.state.CTID);
      var OMT = 2;
      var PCT = 3;
      const remark = rmk;
      const VT = ValidityType;
      var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
      if(orderDetails.BID===""){
        orderDetails.HSE=0
      }
      let cmdtyId = socketDataMap.I;
      let oldQuantity =unformatLang(orderDetails.quantity);
      let OR =unformatLang(orderDetails.OR);
      let processedData={
        IID:cmdtyId,
        PQ:tempQ,
        DT:DealType,
        R:Price,
        OT:OrderType,
        AC:orderDetails.accCode,
        AD:orderDetails.accDescription,
        VD:orderDetails.VD,
        SC:selectedMeasure,
        OMT:OMT,
        PCT:PCT,
        RMK:remark,
        CTID:this.state.CTID,
        VT:VT,
        VTE:validitytime ,
        OPQ:oldQuantity,
        OR:OR,
        OVT:orderDetails.VT,
        OSC:orderDetails.OSC,
        NOD:orderDetails.orderNo,
        BID:orderDetails.BID ,
        OTIME:orderDetails.OTIME,
        PCLD:orderDetails.id,
        DRMK:orderDetails.DRMK,
        language:navigator.language,
        platform:localStorage.getItem('platform'),
        MT:"MODIFY_ORDER",
        browser:navigator.userAgent
      }
      this.setState({processedData})
      this.props.handleModifyLMTOrder(cmdtyId, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, VT, this.state.CTID, validitytime,oldQuantity,OR, orderDetails.VT, orderDetails.OSC, orderDetails.orderNo, orderDetails.BID,orderDetails.id,orderDetails.DRMK,orderDetails.HSE,orderDetails.VD,orderDetails.accCode,orderDetails.accDescription,orderDetails.OTIME);
      wsData=this.getWsDataModifyord(cmdtyId, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, VT, this.state.CTID, validitytime,oldQuantity,OR, orderDetails.VT, orderDetails.OSC, orderDetails.orderNo, orderDetails.BID,orderDetails.id,orderDetails.DRMK,orderDetails.HSE,orderDetails.VD,orderDetails.accCode,orderDetails.accDescription,orderDetails.OTIME)
      let apiValidateData=[{inputData},{processedData},{wsData}]
      this.props.validateOrder(JSON.stringify(apiValidateData));
      this.props.closeLmtModifypopup(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'modifyLmtOrder', component:"ModifyLMTOrderComponent"});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
   if(nextProps.check !== this.props.check){
      if(this.props.cmdtyArr.indexOf(this.state.selectedCmdtyPairKey) !== -1){
           return true;
       }
   }
    if(nextProps.check !== this.props.check){
         return true;
     }
    if(nextState.showLmtDialog !== this.state.showLmtDialog){
      return true;
    }
    if(nextState.errorMsg !== this.state.errorMsg){
      return true;
    }
    if(nextState.time !== this.state.time){
     return true;
    }
    if(nextState.selectedMeasureLmt !== this.state.selectedMeasureLmt){
      return true;
    }
    if(nextState.selectedQuantityLmt !== this.state.selectedQuantityLmt){
      return true;
    }
    if(nextState.DFLMT !== this.state.DFLMT){
      return true;
    }
    if(nextState.OrderType !== this.state.OrderType){
     return true;
    }

    if(nextState.startDatePop !== this.state.startDatePop){
      return true;
    }
    if(nextState.COMLM !== this.state.COMLM){
     return true;
    }
    if(nextState.LMTModel !== this.state.LMTModel){
     return true;
    }
    if(nextProps.trdingFlag !== this.props.trdingFlag){
      return true;
    }
    if(nextProps.status !== this.props.status){
      return true;
    }
    if(nextProps.limitOrdBook !== this.props.limitOrdBook){
      return true;
    }
    if(nextProps.lmtModifyFlag !== this.props.lmtModifyFlag){
       return true;
     }
    if(nextState.Price !== this.state.Price){
      return true;
    }
    if(nextState.selectedLmtRmk !== this.state.selectedLmtRmk){
      return true;
    }
    if(nextState.showPrice !== this.state.showPrice){
      return true;
    }
  return false;
}
afterOpenModal() {
  try{
    const thisComponent = this.refs.modifyLmtOrd;
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    // const elementsData = [
    //   {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
    //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"button"},
    //   {"classNames":"msg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
    //   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
    // ];
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    const directionData = [
      {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"lmtMeasureDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"}
    ];
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName(styles.savetmpBtn)[0], "classNames":styles.savetmpBtn},
        {"elmToHover":thisComponent.getElementsByClassName(styles.exitBtn)[0], "classNames":styles.exitBtn},
        {"elmToHover":thisComponent.getElementsByClassName(styles.cancelBtn)[0], "classNames":styles.cancelBtn}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"ModifyLMTOrderComponent"});
  }
}

  render() {
      const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn trdCloseIcon`} title={i18next.t("close")}/>
      const closeIconImg = <div className={styles.closeIconImg}><img width="16px" src="/images/close.png" /></div>;
      const closeIconofpopup = {  float: 'right'}
      const { selectedMeasureLmt, selectedQuantityLmt, Price, DealType, Quantity, Validty, valueDate, quantityArrayLmt, DFLMT, MEASURE, OrderType,time,
      COM, lmtOrdersRows } = this.state;
      let CmdtyBidFontPosStart=0;let CmdtyBidFontPosEnd=0;
      let CmdtyAskFontPosStart=0;let CmdtyAskFontPosEnd=0;
      if(this.state.cmdtyID !== undefined){
        var socketDataMap = this.props.socketData.get(this.state.cmdtyID);
        CmdtyPair = socketDataMap.cmdty;
        CmdtyAsk = socketDataMap.ask;
        CmdtyBid = socketDataMap.bid;
        if (CmdtyAsk) {
          CmdtyAsk = (parseFloat(socketDataMap.ask) - this.state.stkWiseAskMarkup).toFixed(socketDataMap.dec);
        }
        if (CmdtyBid) {
          CmdtyBid = (parseFloat(socketDataMap.bid) - this.state.stkWiseBidMarkup).toFixed(socketDataMap.dec);
        }
        var mf = JSON.parse(socketDataMap.PTN).mf;
        var rf = JSON.parse(socketDataMap.PTN).rf;
        rateDiff= parseFloat(CmdtyBid) && parseFloat(CmdtyAsk) ? Math.abs(Math.round(((parseFloat(CmdtyBid).toFixed(socketDataMap.dec)-parseFloat(CmdtyAsk).toFixed(socketDataMap.dec)))*mf)).toFixed(rf): '';
        D1 = socketDataMap.D1;
        variationInAsk = socketDataMap.variationInAsk;
        const dealLimit = socketDataMap.dealLimit;
        const validDate = socketDataMap.VD;
        ValueDate=socketDataMap.VD;
        variationInBid = socketDataMap.variationInBid;
        let dec = socketDataMap.dec;
        if (CmdtyBid) {
          CmdtyBidArray = Number(CmdtyBid).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');
          CmdtyBidFontPosStart = CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).bs;
          CmdtyBidFontPosEnd = (CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
        }
        if (CmdtyAsk) {
          CmdtyAskArray = Number(CmdtyAsk).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');
          CmdtyAskFontPosStart = CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).bs;
          CmdtyAskFontPosEnd = (CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
        }
      }
      const isWeekday = date => {
        const day = new Date(date).getDay();
        return day !== 0 && day !== 6;
      };
      // const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
     const stkCodeClass = MEASURE.length == 1 ? true:false;
      return (
        <div id="lmtOrd">
           <div className={`${styles.header} header`}>
              <p className={`${styles.msgTitle} msgTitle`}><span className="trdbookText">{i18next.t("modifyLmtOrd")}</span>: <span>{i18next.t(this.state.ordNo)}</span></p>
              <span onClick={this.closeLimitOrdpopup} className="closeIcon closeIconMdfy">{closeIcon}</span>
            </div>
          <Modal isOpen={this.state.showLmtDialog} className={styles.warningModal} id="modifylmtWarningModal" onAfterOpen={this.afterOpenModal}>
            <div ref="modifyLmtOrd" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                <span onClick={this.closeLmtModal} className={`${styles.closeImg} closeIcon commonCloseIcon`}>
                  {closeIcon}
                </span>
              </div>
              <div className={`${styles.msg} commonMsgDir`}>
                {this.state.errorMsg && this.state.errorMsg != "" ? <p>{renderHTML(this.state.errorMsg)}</p> : null}
              </div>
            </div>
          </Modal>
          <div className={`${styles.LmtWrap} ${this.props.language}`}>
          <div className={`${styles.part1TabContent} part1TabContent`}>
              {this.state.showPrice==="BOTH" && this.props.userDetail.showPriceSpread===true?<div className={`${styles.rateDiff} rateDiff`} >
                  {parseInt(this.props.status) === 0 ? <span> {rateDiff} </span> : null}
              </div>:null}
              {this.state.showPrice==="BOTH"?<div className={variationInBid === 'increment'? `${styles.increment} ${styles.sell} text-center` : `${styles.decrement} ${styles.sell} text-center`} >
                <button className={`${styles.buyRate} ${styles.disabled} buyBg`} >
                  {parseInt(this.props.status) === 0 && CmdtyBidArray && parseFloat(CmdtyBid) > 0 ?
                    <div>
                        {variationInBid ?
                          <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}/></div>
                          : null}
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    :
                    <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                        <div>
                          <p>
                            {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                              return (
                                <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                              );
                            })}
                          </p>
                        </div> : <p>- - - -</p>}
                    </div> }
                </button>
              </div>:null}
              {this.state.showPrice==="BID"?<div className={variationInBid === 'increment'? `${styles.increment} ${styles.modifyOneSidedPrice} text-center` : `${styles.decrement} ${styles.modifyOneSidedPrice} text-center`} >
                <button className={`${styles.buyRate} ${styles.disabled} buyBg`} >
                  {parseInt(this.props.status) === 0 && CmdtyBidArray && parseFloat(CmdtyBid) > 0?
                    <div>
                        {variationInBid ?
                          <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}/></div>
                          : null}
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    : 
                    <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                        <div>
                          <p>
                            {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                              return (
                                <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                              );
                            })}
                          </p>
                        </div> : <p>- - - -</p>}
                    </div> }
                </button>
              </div>:null}
              {this.state.showPrice==="BOTH"?<div className={variationInAsk === 'increment' ? `${styles.increment} ${styles.buy} text-center` : `${styles.decrement} ${styles.buy} text-center`} >
                <button className={`${styles.sellRate} ${styles.disabled} sellBg`} >
                  {parseInt(this.props.status) === 0 && CmdtyAskArray && parseFloat(CmdtyAsk) > 0 ?
                     <div>
                     {variationInAsk ?
                       <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}/></div>
                       : null}
                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    :
                    <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                        <div>

                          <p>
                            {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                              return (
                                <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                              );
                            })}
                          </p>
                        </div> : <p>- - - -</p>}
                    </div> }
                </button>
              </div>:null}
              {this.state.showPrice==="ASK"?<div className={variationInAsk === 'increment' ? `${styles.increment} ${styles.modifyOneSidedPrice} text-center` : `${styles.decrement} ${styles.modifyOneSidedPrice} text-center`} >
                <button className={`${styles.sellRate} ${styles.disabled} sellBg`} >
                  {parseInt(this.props.status) === 0 && CmdtyAskArray && parseFloat(CmdtyAsk) > 0 ?
                     <div>
                     {variationInAsk ?
                       <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}/></div>
                       : null}
                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    : 
                    <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                        <div>

                          <p>
                            {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                              return (
                                <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                              );
                            })}
                          </p>
                        </div> : <p>- - - -</p>}
                    </div> }
                </button>
              </div>:null}
            </div>
            <div className={`${styles.part2TabContent} part2TabContent ${this.props.selectedCssColor}`} id="part2Div">
              <div className={`${styles.rightPart} rightPart ${this.props.language}`}>
                  <div className={`${styles.col3} col3 lmtCmdtyDrpdown`} style={this.props.selectedLang.col3}>
                      <p className="cmdtyType">{D1}</p>
                  </div>
                {this.props.userDetail.disableModQtyField===true ?
                  <div className={ this.state.COMLM===2  && !this.state.isCustInst ? `${styles.qtyselection}` : `${styles.col8} eurQty`} id="LMTQtyMenu"  style={this.props.selectedLang.col5}>
                      <ButtonToolbar>
                        <DropdownButton id="dropdown-size-medium" className="trdDropDown"  disabled>
                           {DFLMT.map((qntity) => {
                            return (
                              <MenuItem onClick={this.quantitySelectionLmt} id="lmtQtySelectionLmt" className="dropDownList" >{qntity}</MenuItem>
                            );
                          })
                        }
                        </DropdownButton>
                      </ButtonToolbar>
                      <input type="text" className={`${styles.dropdownInput} trdDropdownInput`} id="lmtQuantity" value={selectedQuantityLmt}  onBlur={this.onBlurLMT} onChange={this.quantityTypedLmt} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")}disabled/>
                    </div>
                    :
                    <div className={ this.state.COMLM===2  && !this.state.isCustInst ? `${styles.qtyselection}` : `${styles.col8} eurQty`} id="LMTQtyMenu"  style={this.props.selectedLang.col5}>
                        <ButtonToolbar>
                          <DropdownButton id="dropdown-size-medium" className="trdDropDown" >
                             {DFLMT.map((qntity) => {
                              return (
                                <MenuItem onClick={this.quantitySelectionLmt} id="lmtQtySelectionLmt" className="dropDownList" >{qntity}</MenuItem>
                              );
                            })
                          }
                          </DropdownButton>
                        </ButtonToolbar>
                        <input type="text" className={`${styles.dropdownInput} trdDropdownInput`} id="lmtQuantity" value={selectedQuantityLmt}  onBlur={this.onBlurLMT} onChange={this.quantityTypedLmt} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")}/>
                      </div>
                  }
                {this.props.userDetail.disableModQtyField===true ?
                   this.state.COMLM===2  && !this.state.isCustInst ?
                  <div className={`${styles.LMTdropdownDisabled} LMTdropMenu lmtMeasureDiv`} id="lmtMeasure" style={this.props.selectedLang.lmtMeasureDiv} >
                    <ButtonToolbar>
                      <DropdownButton title={selectedMeasureLmt} id="dropdown-size-medium" className={stkCodeClass === true ? "trdDropDown btnText singleOptn":"trdDropDown btnText"}  disabled>
                        {MEASURE && MEASURE.map((unitMeasure) => {
                          return (
                            <MenuItem onClick={this.selectMeasureLmt} id="lmtSelectMeasureLmt" className="dropDownList" >{unitMeasure}</MenuItem>
                          );
                        })
                      }
                      </DropdownButton>
                    </ButtonToolbar>
                  </div>: null
                  : this.state.COMLM===2  && !this.state.isCustInst ?
                  <div className={`${styles.LMTdropdown} LMTdropMenu lmtMeasureDiv`} id="lmtMeasure" style={this.props.selectedLang.lmtMeasureDiv}>
                    <ButtonToolbar>
                      <DropdownButton title={selectedMeasureLmt} id="dropdown-size-medium" className={stkCodeClass === true ? "trdDropDown btnText singleOptn":"trdDropDown btnText"} >
                        {MEASURE && MEASURE.map((unitMeasure) => {
                          return (
                            <MenuItem onClick={this.selectMeasureLmt} id="lmtSelectMeasureLmt" className="dropDownList" >{unitMeasure}</MenuItem>
                          );
                        })
                      }
                      </DropdownButton>
                    </ButtonToolbar>
                  </div>
                  : null}
                </div>
                <div className={`${styles.rightPart} rightPart`}>
                {this.props.userDetail.STOP_ORD === true?
                    <div className={`${styles.col4} LMTdropMenu`} id="lmtDealType">
                      <ButtonToolbar>
                        <DropdownButton title={this.state.DealTypeLang} id="dropdown-size-medium" className="trdDropDown btnText"  disabled>
                          <MenuItem onClick={this.DealType} id="lmtDealTypBuy" className="dropDownList" >{i18next.t("BUY")}</MenuItem>
                          <MenuItem onClick={this.DealType} id="lmtDealTypSell" className="dropDownList" >{i18next.t("SELL")}</MenuItem>
                          <MenuItem onClick={this.DealType} id="lmtOrdDealTyp3" className="dropDownList" >{i18next.t("STOPBUY")}</MenuItem>
                          <MenuItem onClick={this.DealType} id="lmtOrdDealTyp4" className="dropDownList" >{i18next.t("STOPSELL")}</MenuItem>
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>
                    :
                    <div className={`${styles.col4} LMTdropMenu`} id="lmtDealType">
                    <ButtonToolbar>
                        <DropdownButton title={this.state.DealTypeLang} id="dropdown-size-medium" className="trdDropDown btnText"  disabled>
                        <MenuItem onClick={this.DealType} id="lmtDealTypBuy" className="dropDownList" >{i18next.t("BUY")}</MenuItem>
                        <MenuItem onClick={this.DealType} id="lmtDealTypSell" className="dropDownList" >{i18next.t("SELL")}</MenuItem>
                        </DropdownButton>
                    </ButtonToolbar>
                    </div>
                  }
                    <div className={`${styles.col4} ${styles.noPadding} LMTdropMenu `}>
                      <input type="text" className={`${styles.price} trdDropdownInput`} placeholder={i18next.t("price")} id="lmtPrice" onBlur={this.onBlurPrice} value={Price} onChange={this.changePrice} onKeyPress={this.checkNumberValue}/>
                    </div>
                    <div className={`${styles.col4} LMTdropMenu`} >
                      <ButtonToolbar>
                        <DropdownButton title={Validty} id="dropdown-size-medium" className="trdDropDown btnText"  disabled>
                          <MenuItem eventKey={1} onClick={this.Validty} id="lmtValidityGTC" className="dropDownList" >GTC</MenuItem>
                          <MenuItem eventKey={0} onClick={this.Validty} id="lmtValidityDAY" className="dropDownList" >{i18next.t("DAY")}</MenuItem>
                          <MenuItem eventKey={6} onClick={() =>this.Validty} id="lmtOrdGTD" className="dropDownList" >GTD</MenuItem>
                          <MenuItem eventKey={60} onClick={() =>this.Validty} id="lmtOrdGTT" className="dropDownList" >GTT</MenuItem>
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>
                </div>
                {Validty === 'GTD' || Validty === 'GTT' ?
                <div className={`${styles.rightPart} rightPart`}>
                  {Validty === 'GTD' || Validty === 'GTT' ?
                      <div className={Validty === 'GTT'?`${styles.col6} ${styles.valDateRange}`:`${styles.col6} ${styles.valDateRangeGTD}`}>
                        <div className="datepickerInputBox" >
                          <DatePicker readOnly filterDate={isWeekday} selected={this.state.startDatePop} dateFormat="DD-MM-YYYY" onChange={this.handleChange} className="datePickerIcon trdDropdownInput" id="lmtDatePicker"/>
                        </div>
                      </div>
                  : null}
                  { Validty === 'GTT' ?
                    <div className={`${styles.col4} timeField`}>
                      <TimeField id="lmtTimeChng" className={`${styles.inputWidth} form-control`} value={time} onChange={this.onTimeChange} onBlur={this.onBlurTime} />
                      <ButtonToolbar>
                        <DropdownButton title={this.state.timeFormat} className="input-w50">
                          <MenuItem onClick={() =>this.onSelectTimeFormat("AM")} id="timeAM">AM</MenuItem>
                          <MenuItem onClick={() =>this.onSelectTimeFormat("PM")} id="timePM">PM</MenuItem>
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>:null}
                </div>:null}
            <div className={`${styles.comments_wrap_overlay} commentDiv`}>
              <div className={`${styles.comments}`}>
              <textarea ref="comments" rows="1" value={this.state.selectedLmtRmk} placeholder={i18next.t("comments")} onChange={this.onBlurLMTRmk} className={Validty === 'GTD' || Validty === 'GTT' ? `${styles.comment_textarea} form-control trdComments` : `${styles.commentsLmt} form-control trdComments`} id="lmtCommentText"></textarea>
              </div>
            </div>
          </div>
            <div className={`${styles.button_wrapLMT} col-sm-12`}>
              <div className="rightPart">
                <div className={`${styles.col4}`}>
                  &nbsp;
                </div>
                <div className={`${styles.submitbtn} ${styles.col4}  submitBtn`}>
                  <ButtonToolbar>
                  {DealType === 'Buy' || DealType === 'STOP BUY' ?
                    <Button className={this.props.orderStatus===2||this.props.orderStatus===1||parseInt(this.props.status) !== 0||this.state.disableSubmit===true ? `lmtSubmit ${styles.button}  ${styles.disabled}` : `lmtSubmit ${styles.button}`} onClick={() => this.lmtOrderValidate(this.state.COMLM, selectedQuantityLmt, selectedMeasureLmt,Price, CmdtyAsk, ValueDate,OrderType)} id="modifySubmitBtn">{i18next.t("submit")}</Button>
                    :
                    <Button className={this.props.orderStatus===2||this.props.orderStatus===1||parseInt(this.props.status) !== 0||this.state.disableSubmit===true ? `lmtSubmit ${styles.button}  ${styles.disabled}` : `lmtSubmit ${styles.button}`} onClick={() => this.lmtOrderValidate(this.state.COMLM, selectedQuantityLmt, selectedMeasureLmt,Price, CmdtyBid, ValueDate,OrderType)} id="modifySubmitBtn">{i18next.t("submit")}</Button>
                  }
                  </ButtonToolbar>
                </div>
                <div className={`${styles.canceltbtn} ${styles.col4}`}>
                  <ButtonToolbar>
                    <Button className={`lmtClose ${styles.button}`} onClick={this.closeLimitOrdpopup} id="lmtCloseOrdPopUp">{i18next.t("cancel")}</Button>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}
